export const jobCreationConstants = {
    GET_JOB_CREATION_INPUTS_REQUEST: 'GET_JOB_CREATION_INPUTS_REQUEST',
    GET_JOB_CREATION_INPUTS_SUCCESS: 'GET_JOB_CREATION_INPUTS_SUCCESS',
    GET_JOB_CREATION_INPUTS_ERROR: 'GET_JOB_CREATION_INPUTS_ERROR',

    POST_JOB_REQUEST: 'POST_JOB_REQUEST',
    POST_JOB_SUCCESS: 'POST_JOB_SUCCESS',
    POST_JOB_ERROR: 'POST_JOB_ERROR'
};
